(function () {
  'use strict';

  var INJECTED_FLAG = 'data-subscription-roadmap-injected';
  var PILLS_FLAG = 'data-subscription-roadmap-pills-built';

  /* ------------------------------------------------------------------------ */
  /*  Roadmap injection inside Kaching subscribe card                         */
  /* ------------------------------------------------------------------------ */

  function injectIntoSection(section) {
    var subscribeSelector = section.getAttribute('data-subscribe-card-selector')
      || '.kaching-subscriptions__with-explanation .ks-card-wrapper';
    var injectTargetSelector = section.getAttribute('data-inject-target-selector') || '.ks-card';
    var template = section.querySelector('[data-subscription-roadmap-template]');
    if (!template || !template.content) return false;

    var subscribeCardWrapper = document.querySelector(subscribeSelector);
    if (!subscribeCardWrapper) return false;

    var injectTarget = subscribeCardWrapper.querySelector(injectTargetSelector) || subscribeCardWrapper;
    if (!injectTarget) return false;

    if (injectTarget.hasAttribute(INJECTED_FLAG)) return true;

    var clone = template.content.cloneNode(true);
    injectTarget.appendChild(clone);
    injectTarget.setAttribute(INJECTED_FLAG, 'true');

    subscribeCardWrapper.classList.add('subscription-roadmap-host-card');
    return true;
  }

  function tryInjectAll() {
    var sections = document.querySelectorAll('[data-subscription-roadmap-section]');
    if (!sections.length) return true;
    var allDone = true;
    sections.forEach(function (sec) {
      if (!injectIntoSection(sec)) allDone = false;
    });
    return allDone;
  }

  /* ------------------------------------------------------------------------ */
  /*  Pill selector — replaces Kaching bundle bars                            */
  /* ------------------------------------------------------------------------ */

  function placePills(pillsContainer, barsEl) {
    var kachingBlock = barsEl.closest('.kaching-bundles__block') || barsEl.parentNode;
    var stepHeader = kachingBlock.querySelector('.step-header-1');
    if (stepHeader && stepHeader.parentNode) {
      // Insert right after step-header-1 (only if not already there)
      if (pillsContainer.previousElementSibling !== stepHeader) {
        stepHeader.parentNode.insertBefore(pillsContainer, stepHeader.nextSibling);
      }
    } else if (!pillsContainer.parentNode) {
      // Fallback only if pills haven't been inserted yet
      barsEl.parentNode.insertBefore(pillsContainer, barsEl);
    }
  }

  function buildPillsForBars(barsEl) {
    if (!barsEl) return true;
    if (barsEl.hasAttribute(PILLS_FLAG)) {
      // Already built — make sure they stay below step-header-1 if it appeared after initial build
      var existingPills = barsEl.parentNode && barsEl.parentNode.querySelector('.subscription-roadmap-pills');
      if (!existingPills) {
        var block = barsEl.closest('.kaching-bundles__block') || barsEl.parentNode;
        existingPills = block.querySelector('.subscription-roadmap-pills');
      }
      if (existingPills) placePills(existingPills, barsEl);
      return true;
    }

    var dealBars = barsEl.querySelectorAll('.kaching-bundles__bar');
    if (!dealBars.length) return false;

    var pillsContainer = document.createElement('div');
    pillsContainer.className = 'subscription-roadmap-pills';
    pillsContainer.setAttribute('role', 'tablist');

    dealBars.forEach(function (bar) {
      var barId = bar.getAttribute('data-deal-bar-id') || '';
      var titleEl = bar.querySelector('.kaching-bundles__bar-title');
      var title = titleEl ? titleEl.textContent.trim() : barId;
      var isSelected = bar.classList.contains('kaching-bundles__bar--selected');
      var radio = bar.querySelector('input[type="radio"]');

      var pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'subscription-roadmap-pill' + (isSelected ? ' subscription-roadmap-pill--active' : '');
      pill.setAttribute('data-deal-bar-id', barId);
      pill.setAttribute('role', 'tab');
      pill.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      pill.textContent = title;

      pill.addEventListener('click', function (e) {
        e.preventDefault();
        if (radio) radio.click();
      });

      pillsContainer.appendChild(pill);
    });

    // Place pills BELOW the "Choose your deal" step-header if present,
    // otherwise fall back to right before the original bars (will be repositioned later if step-header appears).
    placePills(pillsContainer, barsEl);
    barsEl.classList.add('subscription-roadmap-bars-hidden');
    barsEl.setAttribute(PILLS_FLAG, 'true');

    // Sync pill active state when Kaching changes selection
    var syncObserver = new MutationObserver(function () {
      pillsContainer.querySelectorAll('.subscription-roadmap-pill').forEach(function (p) {
        var bid = p.getAttribute('data-deal-bar-id');
        var bar = barsEl.querySelector('.kaching-bundles__bar[data-deal-bar-id="' + bid + '"]');
        var sel = bar && bar.classList.contains('kaching-bundles__bar--selected');
        p.classList.toggle('subscription-roadmap-pill--active', !!sel);
        p.setAttribute('aria-selected', sel ? 'true' : 'false');
      });
    });
    syncObserver.observe(barsEl, { attributes: true, attributeFilter: ['class'], subtree: true });

    return true;
  }

  function tryBuildPillsAll() {
    if (!document.querySelector('[data-subscription-roadmap-section]')) return true;
    var bars = document.querySelectorAll('.kaching-bundles__bars');
    if (!bars.length) return false;
    var allDone = true;
    bars.forEach(function (b) {
      if (!buildPillsForBars(b)) allDone = false;
    });
    return allDone;
  }

  /* ------------------------------------------------------------------------ */
  /*  Bootstrap                                                               */
  /* ------------------------------------------------------------------------ */

  function tryAll() {
    var aDone = tryInjectAll();
    var bDone = tryBuildPillsAll();
    return aDone && bDone;
  }

  function bootstrap() {
    if (tryAll()) return;

    var observer = new MutationObserver(function () {
      tryAll();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    var checks = 0;
    var poll = setInterval(function () {
      checks++;
      if (tryAll() || checks > 60) {
        clearInterval(poll);
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
